
import { db } from './firebase';
// FIX: Import and alias Timestamp value to avoid name collision with the type
import { Notification, Timestamp } from './types';
import { Timestamp as TimestampValue } from './firebase';

/**
 * Sends a notification directly to a specified user.
 * This function writes to the user's 'notifications' subcollection in Firestore.
 * @param targetUserId The UID of the user who will receive the notification.
 * @param notificationData The content of the notification to be sent.
 */
export const sendDirectNotification = async (
    targetUserId: string, 
    notificationData: Omit<Notification, 'id' | 'time' | 'read'>
) => {
    if (!targetUserId) return;

    const newNotification = {
        ...notificationData,
        // FIX: Use aliased TimestampValue for value access
        time: TimestampValue.now(),
        read: false,
    };

    try {
        const userDoc = await db.collection('users').doc(targetUserId).get();
        if (userDoc.exists) {
            const userData = userDoc.data();
            if (userData && userData.inAppNotificationsEnabled === false) {
                return; // User has disabled in-app notifications
            }
        }

        await db.collection('users')
            .doc(targetUserId)
            .collection('notifications')
            .add(newNotification);
    } catch (e) {
        console.error(`Failed to send direct notification to ${targetUserId}:`, e);
    }
};
